import React, { useState } from "react";
import Contacts from "@/pages/contacts";
const Newzealandvisitvisa = () => {
  const [isOpen, setIsOpen] = useState(false);
 
  const toggleAnswer = () => {
    setIsOpen(!isOpen);
  };
 
  return (
    <>
      <div>
        <div className="h-98 relative w-full">
          <img
            src="/newzelands.jpg" // Replace with the correct path to your image
            alt="Canada Immigration"
            className="h-96 w-full object-cover"
          />
         
        </div>
      </div>
 
      <div className="mt-10 md:ml-64  text-2xl md:text-3xl font-bold text-[#011473] text-center md:text-left">
        Explore New Zealand with a Visitor Visa
      </div>
 
      <div className="flex flex-col items-center py-20 lg:flex-row lg:space-x-8">
        {/* Left Section: Image */}
        <div className="mb-8 flex justify-center lg:mb-0 lg:w-1/2">
          <img
            src="/newzealands.jpg" // Replace with the correct path to your image
            alt="Canada Skilled Migration Documents"
            className="h-96 w-full rounded object-cover shadow-lg"
          />
        </div>
 
        {/* Right Section: Text */}
        <div className="space-y-4 lg:w-1/2">
          {/* First item */}
          <div className="flex items-center">
            <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-blue-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <span className="ml-3 font-medium text-gray-700">
              New Zealand Visit Visa
            </span>
          </div>
 
          {/* Second item */}
          <div className="flex items-center">
            <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-blue-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <span className="ml-3 font-medium text-gray-700">
              Travel to New Zealand for tourism, social, recreational activities, or to visit family and friends.
            </span>
          </div>
 
          {/* Third item */}
          <div className="flex items-center">
            <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-blue-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <span className="ml-3 font-medium text-gray-700">
              Attend business meetings, or seek short-term non-work purposes like medical treatment.
            </span>
          </div>
 
          {/* Fourth item */}
          <div className="flex items-center">
            <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-blue-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <span className="ml-3 font-medium text-gray-700">
              Use the visa if you're just passing through on your way to another country.
            </span>
          </div>
 
          {/* Fifth item */}
          <div className="flex items-center">
            <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-blue-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <span className="ml-3 font-medium text-gray-700">
              Types of Visit Visas: Various visa options are available based on the purpose of your visit.
            </span>
          </div>
 
          {/* Sixth item */}
          <div className="flex items-center">
            <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-blue-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <span className="ml-3 font-medium text-gray-700">
              Eligibility Criteria: Your visa eligibility depends on:
            </span>
          </div>
 
          {/* Seventh item */}
          <div className="flex items-center">
            <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-blue-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <span className="ml-3 font-medium text-gray-700">
              Stay duration
            </span>
          </div>
 
          {/* Eighth item */}
          <div className="flex items-center">
            <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-blue-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <span className="ml-3 font-medium text-gray-700">
              Passport nationality
            </span>
          </div>
 
          {/* Ninth item */}
          <div className="flex items-center">
            <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-blue-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <span className="ml-3 font-medium text-gray-700">
              Current location
            </span>
          </div>
 
          {/* Tenth item */}
          <div className="flex items-center">
            <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-blue-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <span className="ml-3 font-medium text-gray-700">
              Purpose of visit
            </span>
          </div>
        </div>
      </div>
 
      <Contacts />
    </>
  );
};
 
export default Newzealandvisitvisa;
 